import styled from '@xstyled/styled-components'

export const ExcerptLinkListWrap = styled.div``
